// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad = require("../Control.Monad/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Generic_Rep_Show = require("../Data.Generic.Rep.Show/index.js");
var Data_Lens_Prism = require("../Data.Lens.Prism/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var NotValidated = (function () {
    function NotValidated() {

    };
    NotValidated.value = new NotValidated();
    return NotValidated;
})();
var Validating = (function () {
    function Validating() {

    };
    Validating.value = new Validating();
    return Validating;
})();
var $$Error = (function () {
    function $$Error(value0) {
        this.value0 = value0;
    };
    $$Error.create = function (value0) {
        return new $$Error(value0);
    };
    return $$Error;
})();
var Success = (function () {
    function Success(value0) {
        this.value0 = value0;
    };
    Success.create = function (value0) {
        return new Success(value0);
    };
    return Success;
})();
var toMaybe = function (v) {
    if (v instanceof Success) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
};
var genericFormFieldResult = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof NotValidated) {
        return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
    };
    if (x instanceof Validating) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
    };
    if (x instanceof $$Error) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
    };
    if (x instanceof Success) {
        return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)));
    };
    throw new Error("Failed pattern match at Formless.Data.FormFieldResult (line 19, column 1 - line 19, column 74): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return NotValidated.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
        return Validating.value;
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
        return new $$Error(x.value0.value0.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
        return new Success(x.value0.value0.value0);
    };
    throw new Error("Failed pattern match at Formless.Data.FormFieldResult (line 19, column 1 - line 19, column 74): " + [ x.constructor.name ]);
});
var showFormFieldResult = function (dictShow) {
    return function (dictShow1) {
        return new Data_Show.Show(Data_Generic_Rep_Show.genericShow(genericFormFieldResult)(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
            return "NotValidated";
        })))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsNoArguments)(new Data_Symbol.IsSymbol(function () {
            return "Validating";
        })))(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(dictShow))(new Data_Symbol.IsSymbol(function () {
            return "Error";
        })))(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(dictShow1))(new Data_Symbol.IsSymbol(function () {
            return "Success";
        })))))));
    };
};
var functorFormFieldResult = new Data_Functor.Functor(function (f) {
    return function (m) {
        if (m instanceof NotValidated) {
            return NotValidated.value;
        };
        if (m instanceof Validating) {
            return Validating.value;
        };
        if (m instanceof $$Error) {
            return new $$Error(m.value0);
        };
        if (m instanceof Success) {
            return new Success(f(m.value0));
        };
        throw new Error("Failed pattern match at Formless.Data.FormFieldResult (line 21, column 1 - line 21, column 70): " + [ m.constructor.name ]);
    };
});
var fromEither = function (v) {
    if (v instanceof Data_Either.Left) {
        return new $$Error(v.value0);
    };
    if (v instanceof Data_Either.Right) {
        return new Success(v.value0);
    };
    throw new Error("Failed pattern match at Formless.Data.FormFieldResult (line 44, column 14 - line 46, column 23): " + [ v.constructor.name ]);
};
var eqFormFieldResult = function (dictEq) {
    return function (dictEq1) {
        return new Data_Eq.Eq(function (x) {
            return function (y) {
                if (x instanceof NotValidated && y instanceof NotValidated) {
                    return true;
                };
                if (x instanceof Validating && y instanceof Validating) {
                    return true;
                };
                if (x instanceof $$Error && y instanceof $$Error) {
                    return Data_Eq.eq(dictEq)(x.value0)(y.value0);
                };
                if (x instanceof Success && y instanceof Success) {
                    return Data_Eq.eq(dictEq1)(x.value0)(y.value0);
                };
                return false;
            };
        });
    };
};
var applyFormFieldResult = new Control_Apply.Apply(function () {
    return functorFormFieldResult;
}, function (v) {
    return function (v1) {
        if (v instanceof Success) {
            return Data_Functor.map(functorFormFieldResult)(v.value0)(v1);
        };
        if (v instanceof $$Error) {
            return new $$Error(v.value0);
        };
        if (v instanceof Validating) {
            return Validating.value;
        };
        if (v instanceof NotValidated) {
            return NotValidated.value;
        };
        throw new Error("Failed pattern match at Formless.Data.FormFieldResult (line 23, column 1 - line 27, column 38): " + [ v.constructor.name, v1.constructor.name ]);
    };
});
var bindFormFieldResult = new Control_Bind.Bind(function () {
    return applyFormFieldResult;
}, function (v) {
    return function (v1) {
        if (v instanceof Success) {
            return v1(v.value0);
        };
        if (v instanceof $$Error) {
            return new $$Error(v.value0);
        };
        if (v instanceof Validating) {
            return Validating.value;
        };
        if (v instanceof NotValidated) {
            return NotValidated.value;
        };
        throw new Error("Failed pattern match at Formless.Data.FormFieldResult (line 32, column 1 - line 36, column 37): " + [ v.constructor.name, v1.constructor.name ]);
    };
});
var applicativeFormFieldResult = new Control_Applicative.Applicative(function () {
    return applyFormFieldResult;
}, Success.create);
var monadFormFieldResult = new Control_Monad.Monad(function () {
    return applicativeFormFieldResult;
}, function () {
    return bindFormFieldResult;
});
var _Success = function (dictChoice) {
    return Data_Lens_Prism["prism'"](Success.create)(function (v) {
        if (v instanceof Success) {
            return new Data_Maybe.Just(v.value0);
        };
        return Data_Maybe.Nothing.value;
    })(dictChoice);
};
var _Error = function (dictChoice) {
    return Data_Lens_Prism["prism'"]($$Error.create)(function (v) {
        if (v instanceof $$Error) {
            return new Data_Maybe.Just(v.value0);
        };
        return Data_Maybe.Nothing.value;
    })(dictChoice);
};
module.exports = {
    NotValidated: NotValidated,
    Validating: Validating,
    "Error": $$Error,
    Success: Success,
    fromEither: fromEither,
    toMaybe: toMaybe,
    "_Error": _Error,
    "_Success": _Success,
    genericFormFieldResult: genericFormFieldResult,
    eqFormFieldResult: eqFormFieldResult,
    functorFormFieldResult: functorFormFieldResult,
    applyFormFieldResult: applyFormFieldResult,
    applicativeFormFieldResult: applicativeFormFieldResult,
    bindFormFieldResult: bindFormFieldResult,
    monadFormFieldResult: monadFormFieldResult,
    showFormFieldResult: showFormFieldResult
};
